// extracted by mini-css-extract-plugin
module.exports = {"overlay":"MobileOverlay_overlay__2kO6l"};